import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";
import { Identifiable, ProjectPortfolio } from "@planzone/dto";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeProjectPortfolio(
    request: Boundaries["removeProjectPortfolio"]["request"],
  ): void;
}

function useRemoveProjectPortfolio(
  portfolio: Identifiable<ProjectPortfolio>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveProjectPortfolioRequestPending(portfolio),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveProjectPortfolioRequestSuccess(portfolio),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveProjectPortfolioRequestFailure(portfolio),
    ),
    removeProjectPortfolio: core.removeProjectPortfolio,
  };
}

export { useRemoveProjectPortfolio };
